import { useTheme } from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";


const InfoIcon = ({style, ...props}: React.ComponentProps<typeof InfoOutlined>) => {
    const theme = useTheme();
    return (
        <InfoOutlined style={{color: theme.palette.info.main, ...style}} fontSize='small' {...props} />
    )
}
export default InfoIcon;